import { render } from "./1.PartnersParallax.vue?vue&type=template&id=6d2caa3d&scoped=true"
import script from "./1.PartnersParallax.vue?vue&type=script&lang=js"
export * from "./1.PartnersParallax.vue?vue&type=script&lang=js"

import "./1.PartnersParallax.vue?vue&type=style&index=0&id=6d2caa3d&scoped=true&lang=css"
import "./1.PartnersParallax.vue?vue&type=style&index=1&id=6d2caa3d&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d2caa3d"]])

export default __exports__